import mitt from "mitt";
import Util from "@/helper/Utility.js";
/**
 * setting
 * @method setMsg
 * @method clearModal
 * action
 * @method show
 * @method hide
 * set event callback
 * @method onClickOk
 * event
 * @event sendCallbackOk
 */
export function MarketingOptionModalController () {
    this.busModal = mitt();
    this.enableAll = false;
    this.disableAll = false;

    this.callbackSave = null;

    //#region setter
    this.clearModal = function() {
        this.callbackOk = null;
        return this;
    };
    this.setEnableAll = function (enable) {
        this.enableAll = enable;
        return this;
    };
    this.setDisableAll = function (disable) {
        this.disableAll = disable;
        return this;
    };
    //#endregion setter

    //#region method
    this.show = function() {
        var config = {
            enableAll: this.enableAll,
            disableAll: this.disableAll,
        };
        this.busModal.emit('show', config);
    };
    this.hide = function() {
        this.busModal.emit('hide');
    };
    //#endregion method

    //#region event
    this.onSave = function(callback) {
        if (Util.isFunction(callback)) {
            this.callbackSave = callback;
        }
    },
    this.sendCallbackSave = function(data) {
        if (Util.isFunction(this.callbackSave)) {
            this.callbackSave(data);
        }
    };
    //#endregion event
}
